import { ChangeEvent } from "react";
import { svojstvoLicaOption } from "../../../../../../register/register";
import { Aplicant } from "../../../../../../store/CaseReducer";
import KatakomInput from "../../../../../shared/KatakomInput";
import KatakomSelect, { SelectOption } from "../../../../../shared/KatakomSelect";
import { Row } from "../../../../style";

export const PravnoStranac = ({ formData, setFormData }: { formData: Aplicant; setFormData: (aplicant: Aplicant) => void }) => {
    return (
        <>
            <Row>
                <KatakomSelect
                    options={svojstvoLicaOption}
                    value={formData.svojstvoLica || ""}
                    name="svojstvoLica"
                    label="Својство лица*"
                    size="s"
                    error={false}
                    onChange={(option: SelectOption) => setFormData({ ...formData, svojstvoLica: String(option.value) })}
                    style={{ margin: "0 30px 0 0 " }}
                />
                <KatakomInput
                    type="text"
                    value={formData.imePravnogLica || ""}
                    name="imePravnogLica"
                    label="Име правног лица*"
                    size="s"
                    error={false}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => setFormData({ ...formData, imePravnogLica: e.target.value })}
                    style={{ margin: "0 30px 0 0 " }}
                />
                <KatakomInput
                    type="text"
                    value={formData.brojUpisaURegistarDrzaveSedista || ""}
                    name="brojUpisaURegistarDrzaveSedista"
                    label="Број уписа у регистар државе седишта*"
                    size="s"
                    error={false}
                    onChange={(e: ChangeEvent<HTMLInputElement>) =>
                        setFormData({ ...formData, brojUpisaURegistarDrzaveSedista: e.target.value })
                    }
                    style={{ margin: "0 30px 0 0 " }}
                />
                <KatakomInput
                    type="text"
                    value={formData.nazivRegistra || ""}
                    name="nazivRegistra"
                    label="Назив регистра*"
                    size="s"
                    error={false}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => setFormData({ ...formData, nazivRegistra: e.target.value })}
                />
            </Row>
            <Row>
                <KatakomInput
                    type="text"
                    value={formData.email || ""}
                    name="email"
                    label="Е-пошта"
                    size="s"
                    error={false}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => setFormData({ ...formData, email: e.target.value })}
                    style={{ margin: "0 30px 0 0 " }}
                />
                <KatakomInput
                    type="text"
                    value={formData.drzavaNaziv || ""}
                    name="drzavaNaziv"
                    label="Држава*"
                    size="s"
                    error={false}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => setFormData({ ...formData, drzavaNaziv: e.target.value })}
                    style={{ margin: "0 30px 0 0" }}
                />
                <KatakomInput
                    type="text"
                    value={formData.mestoNaziv || ""}
                    name="mestoNaziv"
                    label="Место*"
                    size="s"
                    error={false}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => setFormData({ ...formData, mestoNaziv: e.target.value })}
                    style={{ margin: "0 30px 0 0" }}
                />
                <KatakomInput
                    type="text"
                    value={formData.ulicaRucno || ""}
                    name="ulicaRucno"
                    label="Улица*"
                    size="s"
                    error={false}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => setFormData({ ...formData, ulicaRucno: e.target.value })}
                />
            </Row>
            <Row>
                <KatakomInput
                    type="text"
                    value={formData.kucniBroj || ""}
                    name="kucniBroj"
                    label="Кућни број*"
                    size="s"
                    error={false}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => setFormData({ ...formData, kucniBroj: e.target.value })}
                />
            </Row>
        </>
    );
};
